import { create } from "zustand";
import { persist } from "zustand/middleware";

type Product = {
	sku: number;
	title: string;
	rating: number;
	reviews: number;
	is_add_to_cart_available: boolean;
	currency: string;
	selling_price: number;
	listing_price: number;
	markup: number;
	stock_available: boolean;
	delivery_days: number;
	next_delivery_date: string;
	image: {
		thumbnail: string;
		count: number;
	};
	badges: any[];
	quantity?: number | null;
};

type ViewedProductsState = {
	viewedProducts: Product[];
	clearAllViewedProducts: () => void;
	removeViewedProducts: (skusToRemove: number[]) => void;
	addViewedProduct: (product: Product) => void;
};

const useViewedProducts = create<ViewedProductsState>()(
	persist(
		(set) => ({
			viewedProducts: [],

			clearAllViewedProducts: () => {
				set({ viewedProducts: [] });
			},

			removeViewedProducts: (skusToRemove: number[]) => {
				set((state) => ({
					viewedProducts: state.viewedProducts.filter(
						(product) => !skusToRemove.includes(product.sku)
					),
				}));
			},

			// addViewedProduct: (newProduct: Product) => {
			// 	set((state) => {
			// 		const existingProductIndex = state.viewedProducts.findIndex(
			// 			(product) => product.sku === newProduct.sku
			// 		);

			// 		if (existingProductIndex !== -1) {
			// 			// If product already exists, update it
			// 			const updatedProducts = [...state.viewedProducts];
			// 			updatedProducts[existingProductIndex] = newProduct;
			// 			return { viewedProducts: updatedProducts };
			// 		} else {
			// 			// If product doesn't exist, add it
			// 			return {
			// 				viewedProducts: [
			// 					...state.viewedProducts,
			// 					newProduct,
			// 				],
			// 			};
			// 		}
			// 	});
			// },
			addViewedProduct: (newProduct: Product) => {
				set((state) => {
					const existingProductIndex = state.viewedProducts.findIndex(
						(product) => product.sku === newProduct.sku
					);

					// Maximum number of viewed products
					const maxViewedProducts = 12;

					if (existingProductIndex !== -1) {
						// If product already exists, update it
						const updatedProducts = [...state.viewedProducts];
						updatedProducts[existingProductIndex] = newProduct;
						return { viewedProducts: updatedProducts };
					} else {
						let updatedViewedProducts;
						if (state.viewedProducts.length >= maxViewedProducts) {
							// If maximum number of viewed products reached, remove the first item
							updatedViewedProducts = [
								...state.viewedProducts.slice(1),
								newProduct,
							];
						} else {
							// If product doesn't exist and maximum not reached, add it
							updatedViewedProducts = [
								...state.viewedProducts,
								newProduct,
							];
						}
						return { viewedProducts: updatedViewedProducts };
					}
				});
			},
		}),
		{
			name: "dailysale-shop-viewed-products",
		}
	)
);

export default useViewedProducts;
